module.exports = __webpack_public_path__ + "img/logo_rivha_pilates.60a0fdf6.png";